export default __webpack_public_path__ + "static/media/Baccarat-Mobile-21.162c50db.webp";